import React, { Suspense, lazy } from 'react';

import { reduxConnect } from '../../common';

const LocationsManagerDialog = lazy(() => import('./locationsManagerDialog'));

const mapStoreStateToProps = (storeState: Record<string, unknown>) => {
    const { manageLocationsPopup } = storeState || {};

    const { showManagedLocations } = manageLocationsPopup || {};

    return {
        showManagedLocations
    };
};

const mapDispatchToProps = {};

interface LocationsManagerPopupProps {
    showManagedLocations: boolean;
}

export const LocationsManagerPopup = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ showManagedLocations }: LocationsManagerPopupProps) => {
    return (
        <>
            { showManagedLocations 
                ? <Suspense fallback={<div>Loading...</div>}>
                    <LocationsManagerDialog />
                </Suspense>
                : null }
        </>
    );
});
